<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/Task/TaskList"><span
            class="mdi mdi-arrow-left"></span></a> Task Details</h4>
    </div>

    <div class="card">
      <div class="card-body new-detail-page" *ngIf="formdata?.ProjectNumber">
        <div class="form-row">
          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Task ID:</label>
              <div class="col-sm-8 col">
                <p class="view-value">{{formdata?.TaskNumber}}
                </p>
              </div>
            </div>
          </div>

          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Project Name (Project ID):</label>
              <div class="col-sm-8 col">
                <p class="view-value" *ngIf="formdata?.ProjectNumber">
                  {{formdata?.ProjectName}} ({{formdata?.ProjectNumber}})
                </p>
              </div>
            </div>
          </div>

          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Inquiry Name (Inquiry ID):</label>
              <div class="col-sm-8 col">
                <p class="view-value" *ngIf="formdata?.ProjectNumber">
                  {{formdata?.InquiryName}} ({{formdata?.InquiryNumber}})
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="" *ngIf="isCollapsed">
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Title:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskTitleName}}
                  </p>
                </div>
              </div>
            </div>

            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Status:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskStatusName}}
                  </p>
                </div>
              </div>
            </div>

            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Start Date:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.StartDate}}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">End Date:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.EndDate}}
                  </p>
                </div>
              </div>
            </div>

            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Assigned To:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.AssignedToUserName}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Followers:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.UserName}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Priority:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskPriorityName}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Description:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskDescription}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Remark:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.Remark}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Action Taken:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.ActionTaken}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Outcome Remark:</label>

                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.OutcomeRemark}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12"> </div>
          </div>
        </div>
        <div class="col-auto mt-0 text-right">
          <div class="mb-2 mb-md-0 pt-1">
            <button type="button" class="btn btn-outline-info" (click)="openClosefun()">
              <span *ngIf="!isCollapsed">More</span>
              <span *ngIf="isCollapsed">Less</span>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="formdata?.ProjectNumber=='' && formdata?.InquiryNumber==''" class="card-body new-detail-page">
        <div class="form-row">
          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Task ID:</label>
              <div class="col-sm-8 col">
                <p class="view-value">{{formdata?.TaskNumber}}
                </p>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Task Title:</label>
              <div class="col-sm-8 col">
                <p class="view-value">
                  {{formdata.TaskTitleName}}
                </p>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-4 col-sm-12">
            <div class="row">
              <label class="col-sm-4 col col-form-label">Task Status:</label>
              <div class="col-sm-8 col">
                <p class="view-value">
                  {{formdata.TaskStatusName}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="" *ngIf="isCollapsed">
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Start Date:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.StartDate}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">End Date:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.EndDate}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Assigned To:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.AssignedToUserName}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Followers:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.UserName}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Priority:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskPriorityName}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Task Description:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.TaskDescription}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Remark:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.Remark}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Action Taken:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.ActionTaken}}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Outcome Remark:</label>
                <div class="col-sm-8 col">
                  <p class="view-value">
                    {{formdata.OutcomeRemark}}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-lg-4 col-sm-12"> </div>
          </div>
        </div>

        <div class="col-auto mt-0 text-right">
          <div class="mb-2 mb-md-0 pt-1">
            <button type="button" class="btn btn-outline-info" (click)="openClosefun()">
              <span *ngIf="!isCollapsed">More</span>
              <span *ngIf="isCollapsed">Less</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card-body pt-0 new-detail-page">
        <div class="form-row mt-0">
          <div class="col-md-12 mt-2">
            <ngb-tabset #t="ngbTabset">
              <ngb-tab id="tab-selectbyid6">
                <ng-template ngbTabTitle>Activity History</ng-template>
                <ng-template ngbTabContent>
                  <div class="activity-history mt-3">
                    <ul>
                      <li *ngFor="let detail of history">
                        <div><span><i class="fa fa-calendar-check-o"></i> {{detail.CreatedDate}}</span> <i
                            class="fa fa-user-circle"></i>{{detail.userName}} </div>
                        <p>{{detail.Type}} </p>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </ngb-tab>
            </ngb-tabset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>